import React from 'react';
import { useDarkMode } from '@glu/theming';
import PropTypes from 'prop-types';
import useStyles from './HelpText.styles';

const HelpText = ({ children }) => {
  const dark = useDarkMode();
  const classes = useStyles({ dark });
  return (
    <p className={classes.root}>{children}</p>
  );
};

HelpText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

export default HelpText;
